<div
    class="stats-icon"
    [class.event-scoreboard]="compactScrobeoard()"
    [class.padding-right-small]="betBuilderEpcotEnabled()"
    [class.padding-right]="!betBuilderEpcotEnabled() && statsIconPadding">
    @if (showStats()) {
        <button
            ds-button-icon
            kind="tertiary"
            variant="flat-reduced"
            size="medium"
            class="icon"
            (mouseenter)="toggleHover(mediaType.Stats, true)"
            (mouseleave)="toggleHover(mediaType.Stats, false)"
            (click)="activateMedia($event, mediaType.Stats)">
            <vn-icon size="16" [name]="statsActive() ? activeStatsIcon() : statsIcon()" />
        </button>
    } @else {
        <div class="no-stats-offset"></div>
    }
</div>

<div class="media" [class.event-scoreboard]="compactScrobeoard()">
    @if (hasVideo()) {
        <button
            ds-button-icon
            kind="tertiary"
            variant="flat-reduced"
            size="medium"
            class="icon"
            (mouseenter)="toggleHover(mediaType.Video, true)"
            (mouseleave)="toggleHover(mediaType.Video, false)"
            (click)="activateMedia($event, mediaType.Video)">
            <vn-icon size="16" [name]="videoActive() ? activeVideoIcon() : videoIcon()" />
        </button>
    }
    @if (hasAnimation()) {
        <button
            ds-button-icon
            kind="tertiary"
            variant="flat-reduced"
            size="medium"
            class="icon"
            (mouseenter)="toggleHover(mediaType.Animation, true)"
            (mouseleave)="toggleHover(mediaType.Animation, false)"
            (click)="activateMedia($event, mediaType.Animation)">
            <vn-icon size="16" [name]="animationActive() ? activeAnimationIcon() : animationIcon()" />
        </button>
    } @else {
        <div class="no-animation-offset"></div>
    }
</div>
